export default __webpack_public_path__ + "static/media/explosion.min.77cf29e4.png";